import React from 'react';
import { Navigate } from 'react-router-dom';

// Pickup contact management moved to the account-level page.
// Redirect any bookmarked links to the new location.
const ParentChildPickupContacts: React.FC = () => (
  <Navigate to="/parent/account/pickup-contacts" replace />
);

export default ParentChildPickupContacts;
